import template from './sw-cms-el-config-product-finder.html.twig';
import './sw-cms-el-config-product-finder.scss';

const { Component, Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Component.register('sw-cms-el-config-product-finder', {
    template,

    inject: ['repositoryFactory'],

    mixins: [
        Mixin.getByName('cms-element')
    ],

    data() {
        return {
            productFinderCollection: null
        };
    },

    computed: {
        productFinderRepository() {
            return this.repositoryFactory.create('xps_product_finder');
        },

        productFinderCriteria() {
            const criteria = new Criteria();
            criteria.addFilter(Criteria.equals('active', true));
            criteria.addSorting(Criteria.sort('name', 'ASC'));
            return criteria;
        },

        selectedProductFinder() {
            if (!this.element.config.productFinder.value) {
                return null;
            }

            return this.productFinderCollection?.find(
                finder => finder.id === this.element.config.productFinder.value
            );
        }
    },

    created() {
        this.createdComponent();
    },

    methods: {
        createdComponent() {
            this.initElementConfig('product-finder');
            this.loadProductFinders();
        },

        async loadProductFinders() {
            try {
                const result = await this.productFinderRepository.search(
                    this.productFinderCriteria,
                    Shopware.Context.api
                );
                this.productFinderCollection = result;
            } catch (error) {
                console.error('Error loading product finders:', error);
            }
        },

        onProductFinderChange(productFinderId) {
            this.element.config.productFinder.value = productFinderId;
            this.$emit('element-update', this.element);
        }
    }
});